export enum DINGTALK_USER_PERMISSION {
    PLAIN = '0',
    ADMIN = '1',
}

export enum DINGTALK_APP_ROLES {
    PLAIN = '0',
    MAIN_ADMIN = '1',
    SUB_ADMIN = '2',
}

export enum DINGTALK_AUTH_STATUS {
    UNAUTHORIZED = '0',
    AUTHORIZED = '1',
    DISABLED = '2',
}

export enum DINGTALK_APPLY_STATUS {
    PENDING = '0',
    RESOLVED = '1',
    REJECT = '2',
}

export enum DINGTALK_EMAIL_STATUS {
    VIRTUAL = '1',
    NORMAL = '0',
}

export type DingtalkUserInfoAsLogin = {
    userid: string;
    f_user_id: string; // corresponds to `cUserID`
    unionid: string;
    name: string;
    avatar: string;
    admin: DINGTALK_USER_PERMISSION;
    f_access_token: string;
    app_role: DINGTALK_APP_ROLES;
    app_authed_status: DINGTALK_AUTH_STATUS;
    apply_status: DINGTALK_APPLY_STATUS;
    apply_id: number;
    email?: string;
    is_virtual_email: DINGTALK_EMAIL_STATUS;
}

export type DingtalkUserInfo = {
    corp_id: string;
    user_id: string;
    user_name: string;
    union_id: string;
    cas_id: string;
    email: string;
    is_virtual_email: DINGTALK_EMAIL_STATUS;
    avatar: string;
    app_role: DINGTALK_APP_ROLES;
    app_authed_status: DINGTALK_AUTH_STATUS;
}
